// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"e7bdaf78","241":"a34701e7"}[chunkId] + ".chunk.js";
};